import { FormControl } from '@angular/forms';

// 手机号校验
export function phoneValidator(control: FormControl): any {
    const myReg = /^1[3456789]\d{9}$/;
    const valid = myReg.test(control.value);
    return valid ? null : { phone: true };
}